import { SET_AVVISO } from '../actions/avviso';
import { AvvisoAction } from '../actions/types';

export const setAvviso = (avviso: string | null): AvvisoAction => {
    return {
        type: SET_AVVISO,
        payload: { avviso },
    };
};
